let adminBase = window._env_.VUE_APP_ADMIN_HOST



export const getDepartmentsIndex = params => {
  return axios.post(`${adminBase}/department/query`, params)
}
export const getDepartmentDetail = id => {
  return axios.get(`${adminBase}/department/get_${id}`)
}
export const addDepartment = params => {
  return axios.post(`${adminBase}/department/create`, params)
}
export const editDepartment = params => {
  return axios.post(`${adminBase}/department/edit_${params.id}`, params)
}
export const deleteDepartment = id => {
  return axios.post(`${adminBase}/department/delete_${id}`)
}



// WEBPACK FOOTER //
// ./src/views/platform-department/platform-department.api.js